module.exports = __webpack_public_path__ + "static/img/servicios_juridicos_category.c7bbdd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/servicios_juridicos_category.jpg
// module id = dB8m
// module chunks = 1